import { EventNoun, EventVerb, } from './event.js';
const OPERATION_EVENT_MAP = {
    // Network Events
    updateNetwork: {
        noun: EventNoun.NETWORK,
        verb: EventVerb.UPDATED,
    },
    // Space Events
    createSpace: {
        noun: EventNoun.SPACE,
        verb: EventVerb.CREATED,
    },
    updateSpace: {
        noun: EventNoun.SPACE,
        verb: EventVerb.UPDATED,
    },
    deleteSpace: {
        noun: EventNoun.SPACE,
        verb: EventVerb.DELETED,
    },
    joinSpace: {
        noun: EventNoun.SPACE,
        verb: EventVerb.JOINED,
    },
    leaveSpace: {
        noun: EventNoun.SPACE,
        verb: EventVerb.LEFT,
    },
    // Collection Events
    createCollection: {
        noun: EventNoun.COLLECTION,
        verb: EventVerb.CREATED,
    },
    updateCollection: {
        noun: EventNoun.COLLECTION,
        verb: EventVerb.UPDATED,
    },
    deleteCollection: {
        noun: EventNoun.COLLECTION,
        verb: EventVerb.DELETED,
    },
    // Post Events
    createPost: {
        noun: EventNoun.POST,
        verb: EventVerb.CREATED,
    },
    updatePost: {
        noun: EventNoun.POST,
        verb: EventVerb.UPDATED,
    },
    deletePost: {
        noun: EventNoun.POST,
        verb: EventVerb.DELETED,
    },
    hidePost: {
        noun: EventNoun.POST,
        verb: EventVerb.HIDDEN,
    },
    unhidePost: {
        noun: EventNoun.POST,
        verb: EventVerb.UNHIDDEN,
    },
    createReply: {
        noun: EventNoun.POST,
        verb: EventVerb.CREATED,
    },
    // Member Events
    updateMember: {
        noun: EventNoun.MEMBER,
        verb: EventVerb.UPDATED,
    },
    deleteMember: {
        noun: EventNoun.MEMBER,
        verb: EventVerb.UPDATED,
    },
    // Member Post Notification Settings Events
    updateMemberPostNotificationSettings: {
        noun: EventNoun.MEMBER_POST_NOTIFICATION_SETTINGS,
        verb: EventVerb.UPDATED,
    },
    // Reaction Events
    addReaction: {
        noun: EventNoun.REACTION,
        verb: EventVerb.ADDED,
    },
    removeReaction: {
        noun: EventNoun.REACTION,
        verb: EventVerb.REMOVED,
    },
};
export const createEvent = (query, object, variables) => {
    var _a, _b, _c, _d, _e, _f;
    const operationName = (_f = (_e = (_d = (_c = (_b = (_a = query === null || query === void 0 ? void 0 : query.definitions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.selectionSet) === null || _c === void 0 ? void 0 : _c.selections) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.value;
    if (!(operationName in OPERATION_EVENT_MAP)) {
        return;
    }
    return Object.assign(Object.assign({}, OPERATION_EVENT_MAP[operationName]), { variables, object: object === null || object === void 0 ? void 0 : object[operationName] });
};
